class CustomRichTextReadMore extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.content = this.querySelector('[data-custom-rich-text-read-more-content]');
    this.toggle = this.querySelector('[data-custom-rich-text-read-more-toggle]');
    this.label = this.toggle?.querySelector('.custom-rich-text-read-more__toggle-label');
    this.enabled = this.dataset.enabled === 'true';
    this.expanded = false;
    this.onToggle = this.handleToggle.bind(this);
    this.onResize = this.scheduleMeasure.bind(this);

    this.toggle?.addEventListener('click', this.onToggle);
    window.addEventListener('resize', this.onResize, { passive: true });
    this.style.setProperty('--custom-rich-text-read-more-desktop-lines', this.dataset.desktopLines);
    this.style.setProperty('--custom-rich-text-read-more-mobile-lines', this.dataset.mobileLines);
    this.classList.add('is-ready');
    this.measure();
    this.style.removeProperty('visibility');
  }

  disconnectedCallback() {
    if (!this.initialized) return;

    this.toggle?.removeEventListener('click', this.onToggle);
    window.removeEventListener('resize', this.onResize);
    cancelAnimationFrame(this.frame);
    this.initialized = false;
  }

  getCollapsedHeight() {
    const isDesktop = window.matchMedia('(min-width: 741px)').matches;
    const lines = Number(isDesktop ? this.dataset.desktopLines : this.dataset.mobileLines);
    const computedStyle = window.getComputedStyle(this.content);
    const lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.5;

    return lineHeight * lines;
  }

  measure() {
    if (!this.content || !this.toggle) return;

    if (!this.enabled) {
      this.classList.remove('is-collapsed', 'is-expanded');
      this.toggle.hidden = true;
      return;
    }

    this.classList.add('is-expanded');
    this.classList.remove('is-collapsed');
    const shouldCollapse = this.content.scrollHeight > this.getCollapsedHeight() + 1;

    this.toggle.hidden = !shouldCollapse;
    this.expanded = !shouldCollapse;
    this.classList.toggle('is-expanded', this.expanded);
    this.classList.toggle('is-collapsed', !this.expanded);
    this.toggle.setAttribute('aria-expanded', String(this.expanded));
    this.updateLabel();
  }

  scheduleMeasure() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.measure());
  }

  handleToggle() {
    this.expanded = !this.expanded;
    this.classList.toggle('is-expanded', this.expanded);
    this.classList.toggle('is-collapsed', !this.expanded);
    this.toggle.setAttribute('aria-expanded', String(this.expanded));
    this.updateLabel();
  }

  updateLabel() {
    if (!this.label) return;

    this.label.textContent = this.expanded
      ? this.dataset.readLessText || 'Read Less'
      : this.dataset.readMoreText || 'Read More';
  }
}

if (!customElements.get('custom-rich-text-read-more')) {
  customElements.define('custom-rich-text-read-more', CustomRichTextReadMore);
}
